export function voicemail(state=null, action) {
	switch (action.type) {
		case 'UPDATE_VOICEMAIL':
			return action.voicemail
		default:
			return state
	}
}